const STORAGE_KEY = 'bahlus_profile_identity';

let profileIdentity = null;

function readStoredIdentity() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

function writeStoredIdentity(data) {
  try {
    if (data && typeof data === 'object') {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore
  }
}

export const setProfileIdentity = (data) => {
  profileIdentity = data && typeof data === 'object' ? data : null;
  writeStoredIdentity(profileIdentity);
};

export const getProfileIdentity = () => profileIdentity ?? readStoredIdentity();

export const clearProfileIdentity = () => {
  profileIdentity = null;
  writeStoredIdentity(null);
};
